export default __webpack_public_path__ + "static/media/yogabot_token.911bae15.png";